module.exports = __webpack_public_path__ + "static/media/a31.fc6c4b17.jpg";